import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name:"CustomField",
  props:{
    field_name:{type:String,required:true},
    label:{type:String},
    errMsg:{type:String}
  }
})
